import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

interface OwnProps {
  loading: boolean;
}
type PublicProps = OwnProps;
type Props = PublicProps;

const Loading: React.FC<Props> = (props) => {
  const { loading } = props;

  if (!loading) return null;

  return (
    <div
      style={{
        position: "fixed",
        zIndex: 1301,
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
      }}
    >
      <CircularProgress color="inherit" />
    </div>
  );
};

export default Loading as React.ComponentType<PublicProps>;
